import { createSvgIcon } from "@mui/material/utils";

/**
 * An external service: the service icon (the Jobs list's wrench and hammer)
 * with an outward arrow - service work sent outside the workspace.
 *
 * The Material `Construction` path is scaled to 80% towards the bottom-left,
 * which frees the top-right corner - where it has its wrench head - for the
 * arrow. The arrow is a stroke as thick as the tools' handles, so it stays
 * readable at chip size (18px).
 */
const ExternalServiceIcon = createSvgIcon(
  <>
    <path
      transform="translate(-1.18 6.04) scale(0.8)"
      d="m13.7826 15.1719 2.1213-2.1213 5.9963 5.9962-2.1213 2.1213zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49c-1.17-1.17-3.07-1.17-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21"
    />
    <path d="M15.6 8.4 21.6 2.4M16.2 2.4H21.6V7.8" fill="none" stroke="currentColor" strokeWidth={2} />
  </>,
  "ExternalService"
);

export default ExternalServiceIcon;
